export default "__VITE_ASSET__CVNO87Ko__"